define('cartware_checkout/components/advises/checkout',[
	"jquery",
	"cartware_checkout",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"cartware_checkout/classes/loader",
	"bootstrap-button"
], function(
	jQuery,
	CartwareCheckout,
	Component,
	BEM,
	Loader
) {
	return Component.create({
		loader:		null,

		init: function() {
			var self = this;

			this.loader = new Loader();

			var _initialize = Checkout.prototype.initialize;
			Checkout.prototype.initialize = function() {
				_initialize.apply(this, arguments);

				this.method = 'guest';
				this.steps = ["shipping", "billing", "review"];
			};

			Checkout.prototype.reloadProgressBlock = function (toStep) {
				var updater = new Ajax.Request(this.progressUrl, {
					method: 'get',
					onFailure: this.ajaxFailure.bind(this),
					onSuccess: function(response) {
						var json = response.responseText.evalJSON();

						if (!json) return;

						CartwareCheckout().updateProgress(json);
					},
					parameters: toStep ? {toStep: toStep} : null
				});
			};

			var _setLoadWaiting = Checkout.prototype.setLoadWaiting;
			Checkout.prototype.setLoadWaiting = function(step, keepDisabled) {
				if (step) {
					self.loader.show();
				} else {
					self.loader.hide();
				}

				if (step == 'payment') step = 'billing';
				else if (step == 'shipping-method' || step === true) return;

				//_setLoadWaiting.apply(this, [step, keepDisabled]);

				if (step) {
					if (this.loadWaiting) {
						this.setLoadWaiting(false);
					}
					var container = $(step+'-buttons-container');
					container.addClassName('disabled');
					container.setStyle({opacity:.5});
					this._disableEnableAll(container, true);

					jQuery(container).bemGetElements("button").filter(":modifier(next)").button("loading");
				} else {
					if (this.loadWaiting) {
						var container = $(this.loadWaiting+'-buttons-container');
						var isDisabled = (keepDisabled ? true : false);
						if (!isDisabled) {
							container.removeClassName('disabled');
							container.setStyle({opacity:1});
							jQuery(container).find("[data-loading-text]").button("reset");
						}
						this._disableEnableAll(container, isDisabled);
					}
				}
				this.loadWaiting = step;
			};

			var _gotoSection = Checkout.prototype.gotoSection;
			Checkout.prototype.gotoSection = function(section, forceSection) {
				if (section == "") return;
				if (section == 'review') return; // skip intermediate step
				//if (section == "review") section = "summary";
				//if (section == "login") section = "shipping";

				try {
					if (section == 'payment') section = 'billing';
					else if (section == 'shipping-method') section = 'summary';

					try {
						if ("undefined" !== typeof _gaq) {
							_gaq.push(["_trackEvent", "3-Step Checkout", "gotoSection", section]);
						} else if ("undefined" !== typeof window.ga) {
							window.ga('send', 'pageview', location.pathname.replace(/\/+$/, '') + "/" + section);
						}
					} catch (e) {}


					if (section === "billing") {
						if (!$('billing:different_from_shipping').checked) {
							billing.syncWithShipping();
						}
					}

					if (forceSection) {
						this.currentStep = section;
					}

					if (section == "summary") {
						this.currentStep = "review";
					}

					_gotoSection.apply(this, [section, true]);

					if (section == 'billing') {
						billing.setDifferentFromShipping($('billing:different_from_shipping').checked);
					}
				} catch (e) {
					if ("undefined" != typeof console.log) {
						throw e;
					}
				}
			};

			var _setStepResponse = Checkout.prototype.setStepResponse;
			Checkout.prototype.setStepResponse = function(response) {
				if (response.blocks) {
					if (response.blocks.review) {
						$('checkout-review-wrapper').replace(response.blocks.review);
					}

					if ("shipping-methods" in response.blocks) {
						$('co-shipping-method-form').replace(response.blocks["shipping-methods"]);
					}

					if ("payment-methods" in response.blocks) {
						$('co-payment-block').replace(response.blocks["payment-methods"]);
					}
				}

				_setStepResponse.apply(this, arguments);
			};
		}
	});
});
